import React from "react";

/**
 * BrandText — renders the "ResiliencyHUB" wordmark with a 3D extrusion effect.
 * "HUB" is rendered in vivid Aqua Blue (#00BCD4 / Material Cyan 500) with deeper
 * shadow stack for stronger depth perception.
 *
 * Props:
 *   size: "sm" | "md" | "lg" | "xl"  (default "md")
 *   className: extra classes (e.g. dark/light variant)
 */
export default function BrandText({ size = "md", className = "" }) {
  const sizeMap = {
    sm: "text-base",
    md: "text-xl",
    lg: "text-2xl",
    xl: "text-3xl",
  };
  const baseShadow =
    "0 1px 0 rgba(255,255,255,.45), 0 2px 0 rgba(0,0,0,.18), 0 3px 0 rgba(0,0,0,.12), 0 4px 6px rgba(0,0,0,.22)";
  const aquaShadow =
    "0 1px 0 rgba(255,255,255,.6), 1px 2px 0 #0097A7, 2px 3px 0 #00838F, 3px 4px 0 #006064, 0 5px 10px rgba(0,118,128,.35)";

  return (
    <span
      className={`font-extrabold tracking-tight ${sizeMap[size] || sizeMap.md} ${className}`}
      style={{
        fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
        letterSpacing: "-0.015em",
        textShadow: baseShadow,
        display: "inline-block",
      }}
      data-testid="brand-text"
    >
      Resiliency<span
        style={{
          color: "#00BCD4",
          textShadow: aquaShadow,
          marginLeft: "0",
          display: "inline-block",
          transform: "translateY(-0.5px)",
        }}
      >
        HUB
      </span>
    </span>
  );
}
